<template>
    <div class="info_item">
        <div class="info_item_con">
            <div class="label">工单名称：</div>
            <div class="value">{{info.order_name}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">工单ID：</div>
            <div class="value">{{info.id}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">工单标签：</div>
            <div class="value">{{info.work_order_label}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">创建人部门：</div>
            <div class="value">{{info.user_group_name}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">是否新品：</div>
            <div class="value">{{info.is_new_text}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">游戏类型：</div>
            <div class="value">{{info.project_tag11_text}}</div>
        </div>
         <div class="info_item_con">
            <div class="label">游戏题材：</div>
            <div class="value">{{info.project_tag12_text}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">项目名称：</div>
            <div class="value">{{info.project_name}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">产品：</div>
            <div class="value work-order-products">
                <div v-for="product in info.product_list || []" :key="`${product.product_source}:${product.product_plat_id}:${product.product_key}`"
                     class="work-order-product">
                    <div class="product-name" :title="product.product_name || '-'">{{product.product_name || '-'}}</div>
                    <div class="product-details">
                        <span class="product-meta" :title="`${product.product_plat_name || '-'}｜ID ${product.display_id || product.product_key}`">{{product.product_plat_name || '-'}}｜ID {{product.display_id || product.product_key}}</span>
                        <span v-if="product.subproject_content" class="product-package"
                              :title="`包名：${product.subproject_content}`">包名 {{product.subproject_content}}</span>
                    </div>
                </div>
                <span v-if="!info.product_list || !info.product_list.length">-</span>
            </div>
        </div>
        <div class="info_item_con">
            <div class="label">产品类型：</div>
            <div class="value">{{ info.app_type_text }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">包体类型：</div>
            <div class="value">{{ info.package_type_text||'-' }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">游戏分类：</div>
            <div class="value">{{ info.game_classify_text }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">制作部门：</div>
            <div class="value">{{ info.material_group }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">工单状态：</div>
            <div class="value">{{info.order_status_text}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">排单状态：</div>
            <div class="value">{{info.scheduling_status_text || '-'}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">创建人：</div>
            <div class="value">{{ info.create_name }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">创建时间：</div>
            <div class="value">{{ info.create_time }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">内容要求：</div>
            <div class="value">{{ info.content }}</div>
        </div>
        <div class="info_item_con">
            <div class="label">避免要素：</div>
            <div class="value">{{info.avoid_content}}</div>
        </div>
        <div class="info_item_con" style="color:#ff0000;">
            <div class="label">特殊备注：</div>
            <div class="value">{{info.special_content}}</div>
        </div>
        <div class="info_item_con">
            <div class="label">上传附件：</div>
            <div class="value overflowCon">
                <template v-if="info.attachment && Array.isArray(info.attachment) && info.attachment.length !== 0">
                    <div class="overflowCon_a">
                        <!-- <a :style="{color: '#409EFF', marginBottom: '4px'}"
                           href="javascript:;" key="-index" @click="handleAllDown">下载全部</a> -->
                           <!-- @click="handleOnlyDown(item.attachment_name, item.attachment_path) -->
                        <a :style="{ color: '#409EFF', marginBottom: '4px', cursor: 'text' }"
                           :href="item.attachment_path" target="_blank" v-for="(item, index) in info.attachment" :key="index">{{item.attachment_name}}</a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import {downloadFile} from "@/views/workOrder/components/utils";
import API from "@/api/workOrder/material.js"
export default {
    name: 'componentsMaterialInfo',
    props:['info'],
    data(){
        return {
        }
    },
    methods: {
        handleOnlyDown(name, path) {
            this.$message.warning('文件正在准备下载，请勿重复点击')
            downloadFile({name: name, path: path})
        },
        handleAllDown(){
            API.orderDown({id:this.info.id}).then(res=>{
                this.$message.success(res.info)
            }, err=>{
                this.$message.error(err.info)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.info_item{
    padding: 0 6px;
    .info_item_con{
        /*display: flex;*/
        /*align-items: flex-start;*/
        width: 100%;
        font-size: 12px;
        padding-bottom: 2px;
        line-height: 22px;
        margin-bottom: 6px;
        .label{
            min-width: 64px;
            display: block;
            font-weight: bold;
        }
        .value{
            /*flex: 1;*/
            overflow-x: hidden;
            word-wrap: break-word;
            display: block;
            color: #333;
        }
        .overflowCon{
            overflow-x: auto;
            .overflowCon_a{
                //min-width: 250px;
                display: flex;
                flex-direction: column;
                a{
                    white-space: nowrap;
                }
            }
        }
    }
}
.work-order-product + .work-order-product { margin-top: 6px; }
.work-order-products .product-name,
.work-order-products .product-meta,
.work-order-products .product-package { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.work-order-products .product-details { display: flex; min-width: 0; color: #909399; font-size: 12px; }
.work-order-products .product-meta { flex-shrink: 0; max-width: 55%; }
.work-order-products .product-package { min-width: 0; margin-left: 8px; }
</style>
